__turbopack_context__.v({
  "avatar": "SellerCard-module-scss-module__QSwepq__avatar",
  "card": "SellerCard-module-scss-module__QSwepq__card",
  "country": "SellerCard-module-scss-module__QSwepq__country",
  "image": "SellerCard-module-scss-module__QSwepq__image",
  "imageElement": "SellerCard-module-scss-module__QSwepq__imageElement",
  "images": "SellerCard-module-scss-module__QSwepq__images",
  "imagesContainer": "SellerCard-module-scss-module__QSwepq__imagesContainer",
  "link": "SellerCard-module-scss-module__QSwepq__link",
  "lotNumber": "SellerCard-module-scss-module__QSwepq__lotNumber",
  "name": "SellerCard-module-scss-module__QSwepq__name",
  "noAvatar": "SellerCard-module-scss-module__QSwepq__noAvatar",
  "spacer": "SellerCard-module-scss-module__QSwepq__spacer",
  "textContainer": "SellerCard-module-scss-module__QSwepq__textContainer",
});
